<span
  *ngIf="hasHistories"
  class="icon-tooltip-item history-popover-trigger"
  [ngbTooltip]="tooltip"
  placement="top"
  container="body"
  [popoverTitle]="popoverTitleTpl"
  [ngbPopover]="popoverBodyTpl"
  triggers="manual"
  #popover="ngbPopover"
  [autoClose]="'outside'"
  [placement]="placement"
  container="body"
  [popoverClass]="popoverClass"
  (click)="togglePopover($event, popover)"
  (hidden)="onPopoverHidden()">
  <span [class]="iconClass"></span>
</span>

<ng-template #popoverTitleTpl>
  <div class="d-flex justify-content-between align-items-center w-100 text-white">
    <span class="font-weight-bolder text-white">{{ title }}</span>
    <span class="d-bloc cursor-pointer text-white" (click)="closePopover()"><i [data-feather]="'x'" size="20px"></i></span>
  </div>
</ng-template>

<ng-template #popoverBodyTpl>
  <ul class="timeline mt-2" *ngIf="parsedHistories.length > 0">
    <li class="timeline-item" *ngFor="let item of parsedHistories">
      <span class="timeline-point timeline-point-indicator" [ngStyle]="{ 'background-color': item.color || '#7367f0' }"></span>
      <div class="timeline-event">
        <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
          <h6 class="mb-0 font-weight-bolder">{{ item.title }}</h6>
        </div>
        <p>
          {{ item.description }} <b>{{ item.highlight }}</b> at
          <b>{{ item.formattedDate }}</b>
        </p>
      </div>
    </li>
  </ul>
  <div class="text-center py-2" *ngIf="parsedHistories.length === 0">
    <small class="text-muted">No {{ title.toLowerCase() }} available.</small>
  </div>
</ng-template>
